import React, { useState } from "react";
import { Tab, Tabs, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import StoreInfoTabContent from "./StoreInfoTabContent";
import ProductsTabContent from "./ProductsTabContent";

function StoreInformation({ setShowProductsPage, storeInformationData }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [key, setKey] = useState("info");
  console.log("storeInformationData", storeInformationData);

  return (
    <div>
      {/* Tabs Header Row */}
      <div className="d-flex align-items-center border-bottom">
        <Tabs
          id="vendor-wizard"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="flex-grow-1 border-0"
        >
          <Tab
            eventKey="info"
            title={
              <div style={{ fontSize: 13 }}>
                {storeInformationData?.businessName}
              </div>
            }
          />
          <Tab
            eventKey="products"
            title={<div style={{ fontSize: 13 }}>Products</div>}
          />
        </Tabs>

        {/* Right-side buttons */}
        <div
          className="d-flex align-items-center ms-auto gap-3"
          style={{ paddingRight: "20px" }}
        >
          <Button
            variant="link"
            className="text-secondary fw-medium p-0"
            type="button"
            onClick={() => setShowProductsPage(false)}
          >
            Back
            {/* Cancel */}
          </Button>

          {/* <Button
                        variant="primary"
                        type="button"
                        onClick={() => setShowProductsPage(false)}
                    >
                        Ok
                    </Button> */}
        </div>
      </div>

      {/* Tab Content */}
      <div className="px-3">
        {key === "info" && (
          <>
            <StoreInfoTabContent data={storeInformationData} />
          </>
        )}
        {key === "products" && (
          <>
            <ProductsTabContent storeId={storeInformationData?.id} />
          </>
        )}
      </div>
    </div>
  );
}

export default StoreInformation;
